import { Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { Table } from 'primeng/table';
import { ClassCodeClassNameViewModel, RechazosTracesItemResultsViewModel, RechazosTracesItemViewModel } from '../rechazostraces.types';
import { ListBase } from '../../../../core/_infrastructure/classes/listBase';
import { FilterSearchingBaseViewModel } from '../../../../core/_infrastructure/types/common';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { proxiedPropertiesOf } from '../../../../core/_infrastructure/types/utils';
import { NavMenuService } from '../../../../core/components/navmenu/navmenu.service';

@Component({
    selector: 'app-rechazostraces-list',
    templateUrl: './rechazostraces-list.component.html',
})
export class RechazosTracesListComponent extends ListBase implements OnInit, OnChanges {
    @Input() result: RechazosTracesItemResultsViewModel;
    @Input() lastFilter: FilterSearchingBaseViewModel;
    @Output() search = new EventEmitter<FilterSearchingBaseViewModel>();
    @Output() detail = new EventEmitter<RechazosTracesItemViewModel | null>();
    @Input() isRechazo = false;

    @ViewChild('tableSearch') turboTable: Table;

    cols: any[];

    ProductosCollection: ClassCodeClassNameViewModel[];
    EmbalajesCollection: ClassCodeClassNameViewModel[];

    constructor(
        protected notificationService: NotificationService,
        protected navMenuService: NavMenuService,
    ) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.navMenuService.resetSolicitudData();
        this.loading = false;
        this.initCols();
    }

    private initCols(): void {
        const rechazoTracesVm = proxiedPropertiesOf<RechazosTracesItemViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: rechazoTracesVm.CHEDPP, header: 'CHEDPP' },
            { field: rechazoTracesVm.PaisOrigen, header: 'País de origen' },
            { field: rechazoTracesVm.PaisDestino, header: 'País de destino' },
            { field: rechazoTracesVm.PaisEmision, header: 'País de emisión' },
            { field: rechazoTracesVm.Exportador, header: 'Exportador' },
            { field: rechazoTracesVm.Importador, header: 'Importador' },
            /*{ field: rechazoTracesVm.FechaPresentacion?.toString(), header: 'Fecha de presentación' },*/
            {
                field: rechazoTracesVm.FechaDecision?.toString(),
                header: 'Fecha Decisión',
            },
            //{ field: rechazoTracesVm.Productos, header: 'Productos' },
            //{ field: rechazoTracesVm.Embalajes, header: 'Embalajes' },
            {
                field: 'ProductosEmbalajes',
                header: 'Productos y/o embalajes',
            },
            //{
            //    field: rechazoTracesVm.FechaUltimaActualizacion?.toString(),
            //    header: 'Fecha última actualización',
            //},
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.result?.currentValue) {
            this.result = { ...changes.result.currentValue };
            this.loading = false;

            // Llamamos a una función para establecer las propiedades de la tabla
            this.updateTableProperties();
        }
    }

    private updateTableProperties(): void {
        setTimeout(() => {
            if (this.turboTable) {
                // Establecer los valores de la tabla basados en el filtro correspondiente
                this.turboTable.sortOrder = this.lastFilter?.Asc;
                this.turboTable.sortField = this.lastFilter?.OrderBy;
                this.turboTable.first = this.lastFilter?.PageNumber * this.result.PageSize; // página x elementos por página
            }
        }, 100);
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        const pageNumber = event.first / event.rows;
        this.loading = true;

        const f: FilterSearchingBaseViewModel = {
            PageNumber: pageNumber,
            Asc: event.sortOrder,
            OrderBy: event.sortField,
        };

        this.search.emit(f);
    }

    onDetail(item: RechazosTracesItemViewModel): void {
        this.detail.emit(item);
    }
}
